import type { IUser } from '../users';

export interface IAppUninstallationContext {
    user: IUser;
}
